import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBus"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V7H1V9H3V11.5H21V9H23V7H21V3ZM9 6.4H15V4.6H9V6.4Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21 13H3V21H7V19H17V21H21V13ZM9 17H6V15H9V17ZM15 17H18V15H15V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBus;
